import { useTranslation } from "react-i18next";
import { useLanguageContext } from ".";

export type i18nKey = string | string[];
export type wgKeyPrefix = string;

export const useCustomTranslation = (keyPrefix?: wgKeyPrefix) => {
  const { t: translate } = useTranslation("web-galleries", { keyPrefix });
  const { lng } = useLanguageContext();
  const t = (i18nKey: string | string[], optns?: any) => {
    const options = optns || {};
    if (optns && options?.formatParams?.val?.lng) {
      options.formatParams.val.lng = lng;
    }
    return translate(i18nKey, { lng, ...options })
  };
  return { t };
};
